import {connect} from 'react-redux'
import Menu from '../components/Menu'

export const getVisibleMenuPositions = (menu, isLogged) => {
  const menuPositions=menu.positions;  
  return menuPositions.filter(p => (isLogged || !p.isLogged))
}

const mapStateToProps = state => {  
  return {
    positions: getVisibleMenuPositions(state.menu, state.user.isLogged),    
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

const AppMenu=connect(
  mapStateToProps,
  mapDispatchToProps
)(Menu)

export default AppMenu


// WEBPACK FOOTER //
// ./src/containers/AppMenu.js